type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  style?: React.CSSProperties;
  isNumeric?: boolean;
};

export const SYSTEM_LOCATION_HEADERS: Header[] = [
  {
    key: "medicareId",
    label: "Location ID",
    style: { width: "8%" },
  },
  {
    key: "providerNamelocation",
    label: "Location",
    style: { width: "12%" },
  },
  {
    key: "providerAddressLocation",
    label: "Address",
    style: { width: "16%" },
  },
  {
    key: "physicalCity",
    label: "City",
    style: { width: "8%" },
  },
  {
    key: "physicalState",
    label: "State",
    style: { width: "7%" },
  },
  {
    key: "physicalZip",
    label: "Zip",
    style: { width: "6%" },
  },
  {
    key: "telephoneNumber",
    label: "Phone No",
    style: { width: "10%" },
  },
  {
    key: "faxNumber",
    label: "Fax No",
    style: { width: "9%" },
  },
  {
    key: "emailId",
    label: "Email ID",
    style: { width: "9%" },
  },
  {
    key: "specialInstructions",
    label: "Instructions",
    style: { width: "7%" },
  },
  {
    key: "actions",
    label: "Action",
    style: { width: "8%" },
  },
];

export const MEDICARE_LOGS: Header[] = [
  { key: "createdByName", label: "Created By" },
  { key: "createdDate", label: "Created On" },
  { key: "modifiedByName", label: "Last Modified By" },
  { key: "modifiedDate", label: "Last Modified On" },
];
